// local
import local from './data/local';
import { Loading } from 'element-ui';
import i18n from './lang'

export default {
    // 重定向到戊戌数据
    towuxu(tp = '') {
        let hostname = window.location.hostname;
        // 区分跳转：本地和线上
        // let from = window.location.protocol + '//' + window.location.host;
        let url = (hostname == 'localhost' || hostname == 'trials.wuxuwang.com' || hostname == '192.168.100.110' || hostname == '10.10.10.14') ? '//dev.wuxuwang.com' : '//www.wuxuwang.com';
        // 跳转登录
        if (tp == 'login') {
            //window.location.href = url + '/login?from=' + from;
            window.location.href = '/login';
        } else if (tp == 'apply') {
        // 申请试用
            window.open(url + '/other/kyVipRequest');
        } else if (tp == 'logout') {
        // 退出
            local.set({
                token: '',
                id: '',
                uid: '',
            });
            // window.location.href = url + '/login/out';
            window.location.href = '/login';
        }
    },
    // 可视化水印背景
    canvasbg() {
        //绘制水印
        let canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        canvas.width = 180;
        canvas.height = 140;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.globalAlpha = 0.1;
        ctx.font = '14px Microsoft Yahei,PingFang SC,Verdana,Helvetica Neue,Hiragino Sans GB';
        ctx.translate(60, 30);
        ctx.rotate(-Math.PI / 8);
        ctx.fillText('临研数字化智库平台', 0, 0);
        ctx.font = '16px Microsoft Yahei,PingFang SC,Verdana,Helvetica Neue,Hiragino Sans GB';
        ctx.fillText('www.digitalgcp.com', 5, 20);
        return canvas;
    },
    // 整个页面加载中
    loadingFullPage() {
        let text = '客官稍等，玩命加载中...';
        if (i18n.locale == 'en-us') {
            text = 'Wait, loading...'
        }
        return Loading.service({
            lock: true,
            text: text,
            // spinner: 'el-icon-loading',
            // background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    // 当前url
    nowurl() {
        var res = { httpurl: '', apiurl: '' };
        if (/localhost|192.168.100.110/i.test(location.hostname)) {
            res.httpurl = 'http://192.168.100.110:8081';
            res.apiurl = 'http://apitrials.wuxu.com';
        } else if (/dev.digitalgcp/i.test(location.hostname)) {
            res.httpurl = 'http://dev.digitalgcp.com:1000';
            res.apiurl = 'http://dev-api.digitalgcp.com';
        } else {
            res.httpurl = 'https://www.digitalgcp.com';
            res.apiurl = 'https://api.digitalgcp.com';
        }
        return res;
    },
}